import initializeFormInstallerData from './initializeFormInstallerData';

export default (values) => (dispatch) => {
    dispatch(initializeFormInstallerData(values));
};
